import React, { useState } from 'react';
import { X } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="relative z-50 bg-gradient-to-r from-[#7FD4D4] to-[#5BBFBF] text-black py-2 px-4 text-center" data-id="element-140">
      <div className="container mx-auto flex items-center justify-center relative" data-id="element-141">
        <p className="text-xs md:text-sm font-semibold font-inter tracking-wide" data-id="element-142">
          🎉 15% OFF Your First Car Detailing — Use Code:{' '}
          <span className="font-bold" data-id="element-143">FIRST15</span>
        </p>
        <button onClick={() => setIsVisible(false)} className="absolute right-0 p-1 hover:bg-black/10 rounded-full transition-colors" aria-label="Close banner" data-id="element-144">
          <X size={16} data-id="element-145" />
        </button>
      </div>
    </div>;
}